import React, { Component, type ReactNode } from "react";
import { AlertCircle } from "lucide-react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/**
 * Error Boundary para mensagens da IA no chat.
 * Evita que erros de parsing (Markdown, Mermaid, tabelas) derrubem a aplicação.
 */
export class LimiteMensagemChat extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.warn("[LimiteMensagemChat] Erro ao renderizar mensagem:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="rounded-lg border border-destructive/30 bg-destructive/5 px-4 py-3 text-sm text-destructive">
          <div className="flex items-start gap-2">
            <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" />
            <div>
              <p className="font-medium">Erro ao exibir esta resposta</p>
              <p className="text-xs text-muted-foreground mt-0.5">
                O conteúdo pode conter tabelas ou diagramas que não foram renderizados corretamente.
              </p>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default LimiteMensagemChat;
